import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../layout/card';

export type ChartBlockProps = {
  title: string;
  description?: string;
  children: ReactNode;
  headerMode?: 'full' | 'title-only' | 'hidden';
  headerActions?: ReactNode;
  frameless?: boolean;
  'data-testid'?: string;
};

export function ChartBlock({
  title,
  description,
  children,
  headerMode = 'full',
  headerActions,
  frameless = false,
  'data-testid': testId,
}: ChartBlockProps) {
  if (frameless) {
    return children;
  }

  return (
    <Card data-testid={testId}>
      {headerMode === 'hidden' ? null : (
        <CardHeader>
          <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <CardTitle className="text-base">{title}</CardTitle>
              {headerMode === 'full' && description ? (
                <CardDescription>{description}</CardDescription>
              ) : null}
            </div>
            {headerActions ? <div className="w-full lg:w-auto">{headerActions}</div> : null}
          </div>
        </CardHeader>
      )}
      <CardContent className={headerMode === 'hidden' ? 'pt-6' : undefined}>{children}</CardContent>
    </Card>
  );
}
